export const mapFeatures = (features) =>
  features.map((feature) => {
    const { image, details } = feature;
    return {
      image: {
        src: image?.source?.sourceUrl,
        alt: image?.source?.altText,
        maxWidth: image?.maxWidth,
        maxHeight: image?.maxHeight,
        position: image?.position,
        imageStyle: image?.imageStyle,
      },
      details: {
        title: details?.title,
        description: details?.description,
        features: details?.features,
        table: details?.table,
      },
    };
  });
